import React from 'react'
import "./About_Banner.css"
import Breadcrumb_comp from '../../common/breadcrumb-comp/Breadcrumb_comp';
import Common_title from '../../common/common-title/Common_title';

function About_Banner() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "ABOUT US", link: "", isActive: true },
    ];
    return (
        <>
            <section className='About_Banner'>
                <div className='img_content_holder'>
                    <div className="img_holder">
                        <img src="/assets/images/about/about-banner/about-banner.png" alt="banner img" className='banner_img' />
                    </div>
                    <div className='overlay_text_holder'>
                        <div>
                            <Breadcrumb_comp breadcrumbs={breadcrumbs} />

                            <div className='heading_text_holder'>
                                <Common_title
                                    title={"CAMPUS DEAL "}
                                    subtitle={"About Us"}
                                />
                            </div>

                            <div className='text_holder'>
                                <p>Empowering service connections for homes, offices, and commercial projects.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className='description_holder'>
                        <p>CAMPUS DEAL  is a one-stop platform for finding local service vendors and technical experts. Whether you're building, repairing, or upgrading, CAMPUS DEAL  makes it easy to post your requirement and get quick responses from verified professionals in your city.We bring together customers, hardware shops, and construction experts through a seamless mobile experience.</p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About_Banner